import Service from "../Service";
const resource = "/maturationtunnelpalletreentry/";

export default {

    insert(obj, requestID) {
        return Service.post(resource + "insert", obj, {
            params: { requestID: requestID },
        });
    },


    update(obj, requestID) {
        return Service.post(resource + "update", obj, {
            params: { requestID: requestID },
        });
    },

    entry(obj, requestID) {
        return Service.post(resource + "entry", obj, {
            params: { requestID: requestID },
        });
    },


};